import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "../../../../lib/axios";

const FormCorporateKatalogProgram = (props) => {
  // console.log(props?.user)
  const size = useWindowSize();
  const user = props?.user?.Account !== undefined ? props.user : {};

  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }

  const dispatch = useDispatch();
  const dataInputRegistration = useSelector(
    (state) => state.dataInputRegistration
  );
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [citiesPengiriman, setCitiesPengiriman] = useState([]);
  const [subDistrictsPengiriman, setSubDistrictsPengiriman] = useState([]);

  const kategoriIndustri = [
    "Pertanian, kehutanan, dan perikanan",
    "Training",
    "Pertambangan dan penggalian",
    "Industri pengolahan",
    "Pengadaan listrik, gas, uap/air panas dan udara dingin",
    "Infrastruktur, utilitas, dan transportasi",
    "Konstruksi",
    "Perdagangan besar dan eceran, reparasi dan perawatan kendaraan",
    "Pengangkutan dan pergudangan",
    "Penyediaan akomodasi dan penyediaan makan minum",
    "Informasi dan komunikasi",
    "Aktivitas keuangan dan asuransi",
    "Real estate",
    "Industri Barang Kebutuhan Konsumen",
    "Administrasi pemerintahan, pertahanan dan jaminan sosial wajib",
    "Pendidikan",
    "NGO",
    "Kesehatan dan Farmasi",
    "Aktivitas sewa guna usaha, ketenagakerjaan, agen perjalanan",
    "Aktivitas industri rumah tangga ",
    "Aktivitas badan internasional dan sejenisnya",
    "Aktivitas profesional, ilmiah, dan teknis",
    "Kesenian, hiburan, dan rekreasi",
    "Food & Beverage",
    "Aktivitas jasa lainnya",
  ];

  const handleChangeFormInput = (key, e) => {
    if (key === "SET_PENGIRIMAN_DOKUMEN_PERUSAHAAN") {
      dispatch({ type: key, value: e });
    } else if (key === "SET_FILE_NPWP_PERUSAHAAN") {
      dispatch({ type: key, value: e.target.files[0] });
    } else {
      dispatch({ type: key, value: e.target.value });
    }
  };

  useEffect(() => {
    dispatch({
      type: "SET_NAMA_PERUSAHAAN",
      value: user.Account.name !== null ? user.Account.name : "",
    });
    dispatch({
      type: "SET_JENIS_PERUSAHAAN",
      value: user.Account.companyType !== null ? user.Account.companyType : "",
    });
    dispatch({
      type: "SET_KLASIFIKASI_INDUSTRI",
      value:
        user.Account.industryClassification !== null
          ? user.Account.industryClassification
          : "",
    });
    dispatch({
      type: "SET_STRING_NPWP_PERUSAHAAN",
      value: user.Account.npwp !== null ? user.Account.npwp : "",
    });
    dispatch({
      type: "SET_FILE_NPWP_PERUSAHAAN",
      value: user.Account.npwpFile !== null ? user.Account.npwpFile : "",
    });
    dispatch({
      type: "SET_TELEPON_PERUSAHAAN",
      value: user.Account.phone !== null ? user.Account.phone : "",
    });
    dispatch({
      type: "SET_PROVINSI_ID_PERUSAHAAN",
      value:
        user.Account.billingState !== null ? user.Account.billingState : "",
    });
    dispatch({
      type: "SET_KOTA_ID_PERUSAHAAN",
      value: user.Account.billingCity !== null ? user.Account.billingCity : "",
    });
    dispatch({
      type: "SET_KECAMATAN_ID_PERUSAHAAN",
      value:
        user.Account.billingSubdistrict !== null
          ? user.Account.billingSubdistrict
          : "",
    });
    dispatch({
      type: "SET_KODEPOS_PERUSAHAAN",
      value: user.Account.billingZip !== null ? user.Account.billingZip : "",
    });
    dispatch({
      type: "SET_PATOKAN_PERUSAHAAN",
      value:
        user.Account.billingStreet !== null ? user.Account.billingStreet : "",
    });
    dispatch({
      type: "SET_PROVINSI_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
      value:
        user.Account.shippingState !== null ? user.Account.shippingState : "",
    });
    dispatch({
      type: "SET_KOTA_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
      value:
        user.Account.shippingCity !== null ? user.Account.shippingCity : "",
    });
    dispatch({
      type: "SET_KECAMATAN_ID_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
      value:
        user.Account.shippingSubdistrict !== null
          ? user.Account.shippingSubdistrict
          : "",
    });
    dispatch({
      type: "SET_KODEPOS_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
      value: user.Account.shippingZip !== null ? user.Account.shippingZip : "",
    });
    dispatch({
      type: "SET_PATOKAN_PERUSAHAAN_PENGIRIMAN_DOKUMEN",
      value:
        user.Account.shippingStreet !== null ? user.Account.shippingStreet : "",
    });
  }, []);

  // console.log(user.Account.billingState)

  return (
    <>
      <p
        style={{
          fontSize: size.width < 500 ? "14px" : "16px",
          fontWeight: "400",
          marginBottom: "2%",
        }}
      >
        1. Pastikan data profil perusahaan sudah sesuai.
      </p>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-6">
          <label
            htmlFor="NamaPerusahaan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.namaPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Nama Perusahaan
          </label>
          <input
            type="text"
            id="NamaPerusahaan"
            className="form-control mb-2"
            placeholder="Nama Perusahaan"
            onChange={(e) => handleChangeFormInput("SET_NAMA_PERUSAHAAN", e)}
            value={dataInputRegistration.namaPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.namaPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            disabled={true}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            Contoh: Maju Abadi
          </p>
        </div>
        <div className="col-lg-6 col-12">
          <label
            htmlFor="jenisPerusahaan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.jenisPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Jenis Perusahaan
          </label>
          <select
            className="form-select"
            aria-label="Select example"
            id="jenisPerusahaan"
            onChange={(e) => handleChangeFormInput("SET_JENIS_PERUSAHAAN", e)}
            value={dataInputRegistration.jenisPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.jenisPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            disabled={true}
          >
            <option value="">Pilih</option>
            <option value="PT">PT (Perseroan Terbatas)</option>
            <option value="CV">CV (Persekutuan Komanditer)</option>
            <option value="BUMN">Perusahaan Negara</option>
            <option value="Koperasi">Koperasi</option>
            <option value="Persero">Persero</option>
            <option value="Perseorangan">Perusahaan Perseorangan</option>
            <option value="Firma">Persekutuan Firma</option>
            <option value="Yayasan">Yayasan</option>
          </select>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="KlasifikasiIndustri"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.klasifikasiIndustri.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Klasifikasi Industri
          </label>
          {/* <input type="text" id='KlasifikasiIndustri' className="form-control mb-2" placeholder='Klasifikasi Industri' onChange={(e) => handleChangeFormInput('SET_KLASIFIKASI_INDUSTRI', e)} value={dataInputRegistration.klasifikasiIndustri}
                        style={{ borderColor: (dataInputRegistration.klasifikasiIndustri.length === 0 && dataInputRegistration.inputAlert === true) ? '#F1416C' : '' }}
                    /> */}
          <select
            className="form-select"
            aria-label="Select example"
            id="KlasifikasiIndustri"
            onChange={(e) =>
              handleChangeFormInput("SET_KLASIFIKASI_INDUSTRI", e)
            }
            value={dataInputRegistration.klasifikasiIndustri}
            style={{
              borderColor:
                dataInputRegistration.klasifikasiIndustri.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            disabled={true}
          >
            <option value="">Pilih</option>
            {kategoriIndustri.map((k, i) => (
              <option key={i} value={k}>
                {k}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="StringNpwpPerusahaan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.stringNpwpPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            No. NPWP Perusahaan
          </label>
          <input
            type="text"
            id="StringNpwpPerusahaan"
            className="form-control mb-2"
            placeholder="No. NPWP Perusahaan"
            onChange={(e) =>
              handleChangeFormInput("SET_STRING_NPWP_PERUSAHAAN", e)
            }
            value={dataInputRegistration.stringNpwpPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.stringNpwpPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            disabled={true}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <label
            htmlFor="TeleponPerusahaan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
              color:
                dataInputRegistration.teleponPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
          >
            Telepon Perusahaan
          </label>
          <input
            type="text"
            id="TeleponPerusahaan"
            className="form-control mb-2"
            placeholder="Telepon Perusahaan"
            onChange={(e) => handleChangeFormInput("SET_TELEPON_PERUSAHAAN", e)}
            value={dataInputRegistration.teleponPerusahaan}
            style={{
              borderColor:
                dataInputRegistration.teleponPerusahaan.length === 0 &&
                dataInputRegistration.inputAlert === true
                  ? "#F1416C"
                  : "",
            }}
            disabled={true}
          />
          <p style={{ fontSize: "12px", fontWeight: "400" }}>
            Contoh: 021 77122456
          </p>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12 mb-2">
          <label
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Alamat Perusahaan
          </label>
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Provinsi"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Provinsi
          </label>
          <input
            type="text"
            id="Provinsi"
            className="form-control mb-2"
            placeholder="Provinsi"
            disabled={true}
            value={user?.Account?.billingState}
          />
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kota"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Kota
          </label>
          <input
            type="text"
            id="Kota"
            className="form-control mb-2"
            placeholder="Kota"
            disabled={true}
            value={user?.Account?.billingCity}
          />
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kecamatan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Kecamatan
          </label>
          <input
            type="text"
            id="Kecamatan"
            className="form-control mb-2"
            placeholder="Kecamatan"
            disabled={true}
            value={user?.Account?.billingSubdistrict}
          />
        </div>
        <div className="col-lg-4 col-12">
          <label
            htmlFor="Kodepos"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Kode Pos
          </label>
          <input
            type="text"
            id="Kodepos"
            className="form-control mb-2"
            placeholder="Kode Pos"
            disabled={true}
            value={user?.Account?.billingZip}
          />
        </div>
        <div className="col-lg-8 col-12">
          <label
            htmlFor="PatokanPerusahaan"
            className="form-label"
            style={{
              fontSize: size.width < 500 ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Nama Jalan, Gedung, Nomor/Blok
          </label>
          <input
            type="text"
            id="PatokanPerusahaan"
            className="form-control mb-2"
            placeholder="Nama Jalan, Gedung, Nomor/Blok"
            disabled={true}
            value={user?.Account?.billingStreet}
          />
        </div>
      </div>
      <div className="row" style={{ marginBottom: "2%" }}>
        <div className="col-lg-12 col-12">
          <div className="row" style={{ marginTop: "2%" }}>
            <div className="col-lg-11 col-12 mb-2">
              <label
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Alamat Pengiriman Dokumen
              </label>
            </div>
            <div className="col-lg-4 col-12">
              <label
                htmlFor="ProvinsiPengirimanDokumen"
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Provinsi
              </label>
              <input
                type="text"
                id="ProvinsiPengirimanDokumen"
                className="form-control mb-2"
                placeholder="Provinsi"
                disabled={true}
                value={user?.Account?.shippingState}
              />
            </div>
            <div className="col-lg-4 col-12">
              <label
                htmlFor="KotaPengirimanDokumen"
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Kota
              </label>
              <input
                type="text"
                id="KotaPengirimanDokumen"
                className="form-control mb-2"
                placeholder="Kota"
                disabled={true}
                value={user?.Account?.shippingCity}
              />
            </div>
            <div className="col-lg-4 col-12">
              <label
                htmlFor="KecamatanPengirimanDokumen"
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Kecamatan
              </label>
              <input
                type="text"
                id="KecamatanPengirimanDokumen"
                className="form-control mb-2"
                placeholder="Kecamatan"
                disabled={true}
                value={user?.Account?.shippingSubdistrict}
              />
            </div>
            <div className="col-lg-4 col-12">
              <label
                htmlFor="KodeposPengirimanDokumen"
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Kode Pos
              </label>
              <input
                type="text"
                id="KodeposPengirimanDokumen"
                className="form-control mb-2"
                placeholder="Kode Pos"
                value={user?.Account?.shippingZip}
                disabled={true}
              />
            </div>
            <div className="col-lg-8 col-12">
              <label
                htmlFor="PatokanPerusahaanPengirimanDokumen"
                className="form-label"
                style={{
                  fontSize: size.width < 500 ? "14px" : "16px",
                  fontWeight: "600",
                }}
              >
                Nama Jalan, Gedung, Nomor/Blok
              </label>
              <input
                type="text"
                id="PatokanPerusahaanPengirimanDokumen"
                className="form-control mb-2"
                placeholder="Nama Jalan, Gedung, Nomor/Blok"
                value={user?.Account?.shippingStreet}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormCorporateKatalogProgram;
